export const formatPostalCode = (value: string): string => {
    const numbers = value.replace(/\D/g, '');
    const limitedNumbers = numbers.slice(0, 5);

    if (limitedNumbers.length >= 3) {
        return `${limitedNumbers.slice(0, 2)}-${limitedNumbers.slice(2)}`;
    }

    return limitedNumbers;
};
